import * as tslib_1 from "tslib";
import alwaysDeleteConversationsService from '../services/alwaysDeleteConversationsService';
import createSweepRuleForSenderService from '../services/createSweepRuleForSenderService';
import { setSweepRequestStatus, SweepOptionType } from 'owa-mail-sweep-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { action } from 'satcheljs/lib/legacy';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyOnBulkActionSubmitted } from 'owa-bulk-action-store';
/**
 * The keepNParametersTable is used to hold the keepN parameters that used for
 * ApplyBulkItemAction and CreateSweepRuleForSenderAction
 */
var keepNParametersTable = {};
keepNParametersTable[SweepOptionType.All] = { keepNType: 1 /* Items */, keepNCount: 0 };
keepNParametersTable[SweepOptionType.AllCurrentAndFuture] = {
    keepNType: 1 /* Items */,
    keepNCount: 0,
};
keepNParametersTable[SweepOptionType.AllButOne] = { keepNType: 1 /* Items */, keepNCount: 1 };
keepNParametersTable[SweepOptionType.AllOlderThan] = { keepNType: 0 /* Days */, keepNCount: 10 };
/**
 * Get the keep n parameters from the table
 * @param sweepOptionType the sweep option type
 */
function getKeepNParameters(sweepOptionType) {
    return keepNParametersTable[sweepOptionType];
}
/**
 * Perform the sweep conversations action
 * @param sweepableMailboxes the sweepable mailboxes (ie not your own mailbox)
 * @param tableView the table view
 * @param sweepOptionType the sweep option type
 */
export default action('sweepConversations')(function sweepConversations(sweepableMailboxes, tableView, sweepOptionType) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, keepNType, keepNCount, destinationFolderId, sourceFolderId, senderSMTPs, sweepCustomData;
        return tslib_1.__generator(this, function (_b) {
            _a = getKeepNParameters(sweepOptionType), keepNType = _a.keepNType, keepNCount = _a.keepNCount;
            destinationFolderId = folderNameToId('deleteditems');
            sourceFolderId = tableView.tableQuery.folderId;
            senderSMTPs = sweepableMailboxes.map(function (mailbox) { return mailbox.EmailAddress; });
            sweepCustomData = {
                Scenario: 'Sweep',
                senderSMTPs: senderSMTPs,
                destinationFolderId: destinationFolderId,
            };
            if (isMailFeatureEnabled('tri-bulkActionNotification') &&
                isMailFeatureEnabled('tri-sweepBulkAction')) {
                lazyOnBulkActionSubmitted.importAndExecute(tableView.tableQuery.folderId, 'Sweep', sweepCustomData);
            }
            alwaysDeleteConversationsService(sweepableMailboxes, destinationFolderId, sourceFolderId, keepNType, keepNCount, sweepCustomData);
            if (sweepOptionType == SweepOptionType.All) {
                // No sweep rule needs to be created if sweep operation is to delete all emails from a sender.
                // In that case, just dismiss the dialog
                return [2 /*return*/];
            }
            else {
                // Show 'Creating...' dialog
                setSweepRequestStatus(1 /* Pending */);
            }
            return [2 /*return*/, createSweepRuleForSenderService(sweepableMailboxes, destinationFolderId, sourceFolderId, keepNType, keepNCount)
                    .then(function (response) {
                    if (response.ResponseMessages.Items[0].ResponseClass == 'Success') {
                        // Show complete dialog if request succeeds
                        setSweepRequestStatus(2 /* Complete */);
                    }
                })
                    .catch(function () {
                    // Show error dialog if request fails
                    setSweepRequestStatus(3 /* Error */);
                })];
        });
    });
});
//# sourceMappingURL=sweepConversations.js.map